/**
 * BillingToggle Component
 *
 * Toggle between monthly and yearly billing intervals.
 * Shows savings percentage for yearly billing.
 */

import { Chip } from '@enfomentis/ui';
import type { BillingInterval } from '@enfomentis/shared/types';

interface BillingToggleProps {
  value: BillingInterval;
  onChange: (interval: BillingInterval) => void;
  savingsPercent?: number;
}

export function BillingToggle({
  value,
  onChange,
  savingsPercent = 17,
}: BillingToggleProps) {
  return (
    <div className="flex items-center justify-center gap-3">
      <button
        type="button"
        onClick={() => onChange('month')}
        className={`px-4 py-2 h-10 rounded-lg text-sm font-medium transition-all ${
          value === 'month'
            ? 'bg-primary text-white shadow-md'
            : 'bg-default-100 text-text-secondary hover:bg-default-200'
        }`}
      >
        Monthly
      </button>

      <button
        type="button"
        onClick={() => onChange('year')}
        className={`px-4 py-2 h-10 rounded-lg text-sm font-medium transition-all flex items-center gap-2 ${
          value === 'year'
            ? 'bg-primary text-white shadow-md'
            : 'bg-default-100 text-text-secondary hover:bg-default-200'
        }`}
      >
        Yearly
        {savingsPercent > 0 && (
          <Chip size="sm" color="success" variant="flat">
            Save {savingsPercent}%
          </Chip>
        )}
      </button>
    </div>
  );
}
